import Icon from '../../../preact-components/assets'
import { Filters } from '..'
import { BaseFilterSelectorBuilderData } from '@insided/deprecated-control/overview/filters/interfaces'
import Button from '@insided/control/uikit/Button'

export interface FilterSelector extends BaseFilterSelectorBuilderData {
  type: 'filter'
  component: Function
  getPillDisplayValue: (data: any) => string

  // other option used by the filter component itself
  [key: string]: any
}

export interface SeparatorSelector {
  type: 'separator'
}

export interface TextSelector {
  id: string
  type: 'text'
  name: JSX.Element | string
}

export type FilterList = Array<FilterSelector | SeparatorSelector | TextSelector>

interface FilterSelectorRenderProps {
  isApplyButtonDisabled: boolean
  data: any
}

interface Props {
  areFiltersOpenFromFilterPill: boolean
  selectedFilter: string | undefined
  appliedFilters?: Filters
  filters: FilterList
  onFilterClick: (filterId: string) => void
  onFilterBack: () => void
  onApplyFilters: (id: string, data: any) => void
  onCancelFilters: () => void
  onLoad: (filterId: string, items: any[]) => void
}

const FiltersMenu = ({
  areFiltersOpenFromFilterPill,
  selectedFilter,
  appliedFilters,
  filters,
  onFilterClick,
  onFilterBack,
  onApplyFilters,
  onCancelFilters,
  onLoad
}: Props) => {
  const match = filters.find((filter) => filter.type === 'filter' && filter.id === selectedFilter)

  if (match) {
    const {
      id,
      name,
      component: FilterSelectorComponent,
      isMain,
      ...otherProps
    } = match as FilterSelector

    if (!FilterSelectorComponent) return null

    return (
      <div>
        {areFiltersOpenFromFilterPill || isMain ? (
          <div className='overview__filters-box-header'>{name}</div>
        ) : (
          <div className='overview__filters-box-header-back' onClick={() => onFilterBack()}>
            <Icon width={20} height={20} icon='chevronLeft' />
            <div>{name}</div>
          </div>
        )}
        <div>
          <FilterSelectorComponent
            id={id}
            name={name}
            selectedFilterItems={appliedFilters?.[id] || []}
            onLoad={onLoad}
            {...otherProps}
          >
            {({ isApplyButtonDisabled, data }: FilterSelectorRenderProps) => (
              <div>
                <hr />
                <div className='overview__filters-box-buttons'>
                  <Button
                    size='small'
                    variant='brand'
                    title='Apply'
                    disabled={isApplyButtonDisabled}
                    onClick={() => onApplyFilters(id, data)}
                  />
                  <Button
                    size='small'
                    title='Cancel'
                    onClick={() => onCancelFilters()}
                  />
                </div>
              </div>
            )}
          </FilterSelectorComponent>
        </div>
      </div>
    )
  }

  return (
    <div>
      {filters
        .filter((filter) => filter.type !== 'filter' || !filter.isMain)
        .map((filter, index) => {
          if (filter.type === 'separator') {
            return <hr key={index} className='separator' />
          }

          if (filter.type === 'text') {
            return (
              <div className='overview__filters-box-text' key={filter.id}>
                {filter.name}
              </div>
            )
          }

          return (
            <div
              className={`overview__filters-box-filter qa-${filter.id}-selector`}
              key={filter.id}
              onClick={() => onFilterClick(filter.id)}
            >
              <span>{filter.name}</span>
            </div>
          )
        })}
    </div>
  )
}

export default FiltersMenu
